(() => {
  if (window.customAddToCartLoadingInitialized) {
    return;
  }

  window.customAddToCartLoadingInitialized = true;

  const BUTTON_SELECTOR = '.custom-add-to-cart-btn';
  const LOADING_ATTRIBUTE = 'data-loading';
  const SAFETY_TIMEOUT = 10000;

  let safetyTimeoutId = null;

  const stopLoading = () => {
    clearTimeout(safetyTimeoutId);

    document.querySelectorAll(`${BUTTON_SELECTOR}[${LOADING_ATTRIBUTE}]`).forEach((button) => {
      button.removeAttribute(LOADING_ATTRIBUTE);
    });
  };

  const startLoading = (button) => {
    button.setAttribute(LOADING_ATTRIBUTE, 'true');
    clearTimeout(safetyTimeoutId);
    safetyTimeoutId = setTimeout(stopLoading, SAFETY_TIMEOUT);
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target instanceof Element ? event.target.closest(BUTTON_SELECTOR) : null;

      if (!button || button.disabled || button.hasAttribute(LOADING_ATTRIBUTE)) {
        return;
      }

      if (button.form && !button.form.checkValidity()) {
        return;
      }

      startLoading(button);
    },
    { capture: true }
  );

  // The theme drops `aria-busy` as soon as `/cart/add.js` resolves, but the drawer only opens
  // after the follow-up cart request, so the state has to be held until the cart events fire.
  ['variant:add', 'cart:change', 'cart:error'].forEach((eventName) => {
    document.addEventListener(eventName, stopLoading);
  });

  window.addEventListener('pageshow', stopLoading);
})();
